module.exports = __webpack_public_path__ + "media/assets/images/blog/short-small-1cf9775e5cc425f8ca5f4a5a039f5f2b.jpg";